import { FC } from 'react';
import { useState } from 'react';
import { useWeb3React } from 'hooks/web3';
import { IoClose } from 'react-icons/io5';
import { getNumberWithOrdinal } from '../../../utils/number';
import { Proposal } from 'types/snapshot';
import { useModal } from 'store/modals';
import {
  VStack,
  Box,
  Text,
  Button,
  IconButton,
  Grid,
  GridItem
} from '@chakra-ui/react';
import { ModalType } from 'components/modals/types';

type Props = {
  proposal: Proposal;
};

const RankedForm: FC<Props> = ({ proposal }) => {
  const { openModal } = useModal();
  const { choices } = proposal;
  const { account } = useWeb3React();
  const [ranks, setRanks] = useState<number[]>([]);

  const handleAdd = (choicePosition: number) => {
    if (!ranks.includes(choicePosition)) {
      setRanks((prevRanks) => [...prevRanks, choicePosition]);
    }
  };

  const handleClose = (choicePosition: number) => {
    if (ranks.includes(choicePosition)) {
      setRanks((prevRanks) =>
        prevRanks.filter((rank) => rank !== choicePosition)
      );
    }
  };

  const handleVote = () => {
    openModal(ModalType.vote, {
      proposal,
      data: ranks
    });
  };

  return (
    <VStack alignItems='stretch' spacing={4}>
      {choices.map((choice, idx) => {
        return (
          <Box
            p={3}
            key={choice}
            borderWidth={1}
            borderRadius='xl'
            onClick={() => handleAdd(idx + 1)}
            borderColor={ranks.includes(idx + 1) ? 'white' : 'gray.700'}
            _hover={{
              cursor: 'pointer'
            }}
          >
            <Grid templateColumns='repeat(5, 1fr)' alignItems='center'>
              <GridItem>
                {ranks.find((rank) => rank === idx + 1) && (
                  <Text textAlign='left' pl={2}>
                    {getNumberWithOrdinal(
                      ranks.findIndex((rank) => rank === idx + 1) + 1
                    )}
                  </Text>
                )}
              </GridItem>
              <GridItem colSpan={3}>
                <Text textAlign='center'>{choice}</Text>
              </GridItem>
              <GridItem justifySelf='flex-end'>
                {ranks.includes(idx + 1) && (
                  <IconButton
                    size='sm'
                    bg='gray.800'
                    aria-label='remove'
                    variant='ghost'
                    icon={<IoClose />}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleClose(idx + 1);
                    }}
                  />
                )}
              </GridItem>
            </Grid>
          </Box>
        );
      })}
      <Button
        size='lg'
        disabled={ranks.length === 0 && !!account}
        onClick={
          !account ? () => openModal(ModalType.connectWallet) : handleVote
        }
      >
        {!account ? 'Connect Wallet' : 'Vote'}
      </Button>
    </VStack>
  );
};

export default RankedForm;
